import baseBreakpoints from '@shop/styleguide/dist/js/breakpoints'

// Manage theme name in order to import the right one
const theme = {
  name: 'zooplus' // This should be variable
};

const breakpoints = {
  tiny: baseBreakpoints.breakpointTiny,
  small: baseBreakpoints.breakpointSmall,
  medium: baseBreakpoints.breakpointMedium,
  large: baseBreakpoints.breakpointLarge
}

const getNumberFromString = (definition) => {
  return Number.parseInt(definition.match(/\d+/g)[0], 10)
}

const breakpointsNumeric = {
  tiny: getNumberFromString(breakpoints.tiny),
  small: getNumberFromString(breakpoints.small),
  medium: getNumberFromString(breakpoints.medium),
  large: getNumberFromString(breakpoints.large)
}

const media = {
  mobile: `(min-width: ${breakpoints.tiny})`,
  mobileL: `(min-width: ${breakpoints.small})`,
  tablet: `(min-width: ${breakpoints.medium})`,
  desktop: `(min-width: ${breakpoints.large})`
}

const mediaMax = {
  mobile: `(max-width: ${breakpoints.tiny})`,
  mobileL: `(max-width: ${breakpoints.small})`,
  tablet: `(max-width: ${breakpoints.medium})`,
  desktop: `(max-width: ${breakpoints.large})`
}

export {theme, breakpoints, breakpointsNumeric, media, mediaMax};
